var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 268,
    height: 160,
    viewBox: "0 0 268 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.6428 145.286C32.5233 145.286 -1.42164e-06 112.762 -3.17532e-06 72.6428C-4.929e-06 32.5233 32.9056 -6.24735e-05 73.0252 -6.42272e-05C113.569 -6.59994e-05 146.823 32.8674 146.823 73.4115L146.823 145.286L72.6428 145.286Z",
    fill: "#9E0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M157.201 106.509C157.201 89.7154 170.814 76.1019 187.607 76.1019H191.024C210.128 76.1019 225.616 91.5892 225.616 110.694C225.616 129.798 210.128 145.286 191.024 145.286H157.201V106.509Z",
    fill: "#115264"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5635 59.2933L74.0697 97.6372L97.4094 59.2933",
    stroke: "white",
    strokeWidth: 1.92177
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M119.916 99.3016H27.9458L74.6253 19.5575L119.916 99.3016Z",
    stroke: "white",
    strokeWidth: 1.92177
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2231 45.9539L120.193 45.9539L73.5134 125.698L28.2231 45.9539Z",
    stroke: "white",
    strokeWidth: 1.92177
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.501 46.233L73.7912 72.6292V125.421",
    stroke: "white",
    strokeWidth: 1.92177
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M119.636 45.9519L73.5122 72.6259",
    stroke: "white",
    strokeWidth: 1.92177
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5635 59.2933H96.8537",
    stroke: "white",
    strokeWidth: 1.92177
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 174.881,
    cy: 49.5813,
    r: 17.2959,
    fill: "#F4A807"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardImage);
export default __webpack_public_path__ + "static/media/dashboardImage.69175acc2a8c8c84200cca374507fcff.svg";
export { ForwardRef as ReactComponent };